import { useLocation, useNavigate } from 'react-router-dom'
import { Analytics } from '@genoa/analytics'
import { SLCType } from '@genoa/domain'
import { AmplitudeFeatureFlag } from '@genoa/experiments'

import { useSecureLineOfCredit } from '../../../../../../hooks'
import { useAmplitudeFeatureFlag } from '../../../../../../hooks/use-amplitude-feature-flag'
import { useAnalytics, useFees } from '../../../../../../providers'
import * as Routes from '../../../../../../routing/constants'
import { useConfirmSchedule } from '../balance-out-of-range/useConfirmSchedule'
import { DelayedLoading } from '../simplified-episodic/DelayedLoading'
import { BalanceOutOfRangePaymentSchedule } from './BalanceOutOfRangePaymentSchedule'
import { usePaymentItems } from './usePaymentItems'
import { usePaymentSchedule } from './usePaymentSchedule'
import {
  getPropertyPassthroughFeeFromPaymentSchedule,
  usePaymentStatusListToSchedule,
} from './usePaymentStatusToSchedule'

export const BalanceOutOfRangePaymentScheduleContainer = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const analytics = useAnalytics()
  const confirmSchedule = useConfirmSchedule()
  const { subscriptionFee } = useFees()
  const { slcType } = useSecureLineOfCredit()
  const { enabled: janBPRefactorEnabled } = useAmplitudeFeatureFlag(AmplitudeFeatureFlag.PaymentStatusRefactorJanBP)

  const { processingFeePercentage, paymentItems } = usePaymentSchedule(
    location.state.payments,
    false,
    location.state.processingFeePercentage / 100
  )

  const payments = usePaymentItems(location.state.payments)
  const propertyPassthroughFee = getPropertyPassthroughFeeFromPaymentSchedule(location.state.payments)

  const handleConfirmScheduleSuccess = async () => {
    analytics.logEvent(Analytics.Events.EMBED_BALANCE_OUT_OF_RANGE_SCHEDULE_SUCCESS)
    navigate(Routes.Embed.BALANCE_OUT_OF_RANGE_PAYMENT_SCHEDULE_SUCCESS, {
      replace: true,
      state: { amount: paymentItems.rentAmount },
    })
  }

  const handlePressConfirm = () => {
    analytics.logEvent(Analytics.Events.EMBED_BALANCE_OUT_OF_RANGE_SCHEDULE_CLICKED)
    confirmSchedule.submit(location.state.overwritePublicId, handleConfirmScheduleSuccess)
  }

  const paymentStatusScheduleList = usePaymentStatusListToSchedule(location.state.paymentStatus || [])
  const paymentStatusSchedule =
    janBPRefactorEnabled && !!location.state.paymentStatus?.length ? paymentStatusScheduleList : undefined

  if (confirmSchedule.isConfirming) {
    return <DelayedLoading />
  }

  return (
    <BalanceOutOfRangePaymentSchedule
      isSlc={!!slcType}
      membershipFee={paymentItems.membershipFeeValue}
      onMembershipInfoPress={() =>
        paymentItems.handlePressMembershipFeeInfo(Analytics.Events.OUT_OF_RANGE_PAYMENT_SCHEDULE_FEE_INFO_CLICKED)
      }
      onPressConfirm={handlePressConfirm}
      payments={payments}
      paymentStatusSchedule={paymentStatusSchedule}
      processingFeePercentage={processingFeePercentage}
      propertyPassthroughFee={propertyPassthroughFee}
      rentAmount={paymentItems.rentAmount}
      scheduleList={paymentItems.schedule}
      showProcessingFee={!!subscriptionFee && slcType !== SLCType.CREDIT_BUILDER}
    />
  )
}
